module.exports = __webpack_public_path__ + "img/pp.77c072a1.svg";